export const LogoMark = ({ className = "h-9 w-auto", light = false }) => {
  const ink = light ? "#ffffff" : "#133a48";
  return (
    <svg viewBox="0 0 120 100" className={`shrink-0 ${className}`} role="img" aria-label="Stop Cheni" data-testid="logo-mark">
      <path d="M13.25 38.5 A34.6 36.5 0 0 1 82.5 38.5 Z" fill="#f0b323" />
      <rect x="42" y="0.5" width="12" height="5" rx="2.5" fill="#f0b323" />
      <rect x="9" y="37.5" width="78" height="7.5" rx="3.75" fill="#f0b323" />
      <path d="M32.5 8 L38.7 23.5 M63.5 8 L57.3 23.5" stroke={light ? "#12303f" : "#fff"} strokeWidth="2.4" strokeLinecap="round" />
      <path d="M10 58.75 C 18 70 32 77 45 77 C 58 77 72 70 80 58.75 L 95 68.75 C 88 80 70 88.75 50 88.75 C 30 88.75 14 78 8.75 63.75 Z" fill={ink} />
      <path d="M3.9 67.5 C 2.6 60 6 54 12.5 53.8 C 15 53.7 16.5 54 17.5 55" fill="none" stroke={ink} strokeWidth="3.2" strokeLinecap="round" />
      <path d="M82.5 56.25 C 83.5 52.5 87 50.5 91 51.5 L 95.5 53.5 C 98.5 56 99.5 61 97.5 65.5 Z" fill={ink} />
      <path d="M93.75 51.25 L 113.25 28.75" stroke={ink} strokeWidth="3.6" strokeLinecap="round" />
    </svg>
  );
};
